module.exports = __webpack_public_path__ + "static/media/Tormund Giantsbane 1.88a22f1c.jpg";